import { md5Hash } from '@dcb/utils'

/**
 * 计算 SKU 唯一标识。
 *
 * @param ids 商品 ID、商品规格 ID 列表、商品规格值 ID 列表组成的数组
 */
export function calcSkuId(ids: string[]): string {
  // 第一步：将商品 ID、商品规格 ID 列表、商品规格值 ID 列表组合为一个数组
  const arr = ids.slice()

  // 第二步：将第一步的结果数组做原地自然排序
  arr.sort()

  // 第三步：用 & 将以上步骤产生的结果数组拼接为一个字符串
  const str = arr.join('&')

  // 第四步：对第三步的结果字符串做 md5 哈希即得 SKU 唯一标识
  const skuId = md5Hash(str)

  return skuId
}
